import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('about');
  this.route('services', function () {
    this.route('index', {
      path: ''
    });
    this.route('detail', {
      path: '/:name/:cluster_id/:partition/:namespace'
    }, function () {
      this.route('overview', {
        path: ''
      }, function () {
        this.route('metrics');
      });
      this.route('topology');
      this.route('instances');
    });
  });
  this.route('clusters', function () {
    this.route('overview', {
      path: ''
    });
    this.route('create');
    this.route('self-managed', function () {
      this.route('bootstrap');
      this.route('link-existing');
      this.route('detail', {
        path: '/:name'
      }, function () {
        this.route('peering');
        this.route('observability');
        this.route('certificates');
      });
    });
    this.route('hcp', function () {
      this.route('deploy', {
        path: '/cluster/deploy'
      }, function () {
        this.route('select-method', {
          path: '/:provider'
        }, function () {
          this.route('complete-deployment', {
            path: '/:method'
          });
        });
      });
      this.route('detail', {
        path: '/:name'
      }, function () {
        this.mount('snapshots', {
          path: '/snapshots'
        });
        this.mount('monitoring', {
          path: '/monitoring'
        });
        this.route('edit');
        this.route('federation', function () {
          this.route('create');
        });
        this.route('peering');
        this.route('observability');
      });
    });
  });
  this.route('peering', function () {
    this.route('list', {
      path: ''
    });
    this.route('create');
  });
});